import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderCheckbox,
  renderDateTextField2,
  renderMultiLineTextField,
  renderSelectField6,
  renderTextField,
} from '../../form-global-components/components-form-components-for-react-final-form';
import {
  ATTEMPTED_CONTACT_RESULTS,
  ATTEMPTED_CONTACT_EMPLOYED_STATUS_RESULTS,
  EDUCATION_ACHIEVEMENT_OR_CHANGES,
  FAMILY_AND_SIGNIFICANT_OTHERS,
  POST_DISCHARGE_SUBSTANCE_USE,
  POST_DISCHARGE_RATE_QUALITY_OF_LIFE,
  NO_YES,
} from '../../../actions/action-constants';
class FormFieldsPostDischargeTabPostDischargeStatus extends Component {
  render() {
    return (
      <div>

        <Paper >
                                                                                        {/* 
                                                                                                  <CardHeader/>
                                                                                                  <Divider /> 
                                                                                        */}
          <Card>
            <CardContent>

            <Grid container spacing={3}>
              <Grid item xs={12} >
                  <Field
                    locked={true}
                    component={renderDateTextField2}
                    id='clientdischargedate'
                    name='clientdischargedate'
                    label='Client Discharge Date'
                  />
              </Grid>
            </Grid>

<br />
<hr />
<br />

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  locked={this.props.locked}
                  component={renderDateTextField2}
                  id='postdischargecontactdate90d'
                  name='postdischargecontactdate90d'
                  label='Post Discharge Attempted Contact Date 90 days'
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={ATTEMPTED_CONTACT_RESULTS}
                  id='postdischargeattemptedcontact90desults'
                  name='postdischargeattemptedcontact90desults'
                  label='Attempted Contact 90 Days Results'
                  footerMessage=''
                />
              </Grid>
            </Grid>

postdischargeattemptedcontact180dresults
postdischargeattemptedcontact12mresults
postdischargeattemptedcontact24mresults
postdischargeattemptedcontact36mresults

            { (this.props.postdischargecontactdate90dSelected ) 
            ?
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}                        
                    component={renderDateTextField2}
                    id='postdischargecontactdate180d'
                    name='postdischargecontactdate180d'
                    label='Post Discharge Attempted Contact Date 180 days'
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={ATTEMPTED_CONTACT_RESULTS}
                    id='postdischargeattemptedcontact180dresults'
                    name='postdischargeattemptedcontact180dresults'
                    label='Attempted Contact 180 Days Results'
                    footerMessage=''
                  />                  
                </Grid>
              </Grid>
            </>
            : null }

            { (this.props.postdischargecontactdate180dSelected ) 
            ?
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}                      
                    component={renderDateTextField2}
                    id='postdischargecontactdate12m'
                    name='postdischargecontactdate12m'
                    label='Post Discharge Attempted Contact Date 12 Months'
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={ATTEMPTED_CONTACT_RESULTS}
                    id='postdischargeattemptedcontact12mresults'
                    name='postdischargeattemptedcontact12mresults'
                    label='Attempted Contact 12 Months Results'
                    footerMessage=''
                  />
                </Grid>
              </Grid>
            </>
            : null }

            { (this.props.postdischargecontactdate12mSelected ) 
            ?
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}                      
                    component={renderDateTextField2}
                    id='postdischargecontactdate24m'
                    name='postdischargecontactdate24m'
                    label='Post Discharge Attempted Contact Date 24 Months'
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={ATTEMPTED_CONTACT_RESULTS}
                    id='postdischargeattemptedcontact24mresults'
                    name='postdischargeattemptedcontact24mresults'
                    label='Attempted Contact 24 Months Results'
                    footerMessage=''
                  />
                </Grid>
              </Grid>
            </>
            : null }

            { (this.props.postdischargecontactdate24mSelected ) 
            ?
            <>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                 <Field
                    locked={this.props.locked}                      
                    component={renderDateTextField2}
                    id='postdischargecontactdate36m'
                    name='postdischargecontactdate36m'
                    label='Post Discharge Attempted Contact Date 36 Months'
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={ATTEMPTED_CONTACT_RESULTS}
                    id='postdischargeattemptedcontact36mresults'
                    name='postdischargeattemptedcontact36mresults'
                    label='Attempted Contact 36 Months Results'
                    footerMessage=''
                  />
                </Grid>
              </Grid>
            </>
            : null }

 
<br />
<hr />
<br />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargephysicalvisitstoer'
                    name='postdischargesincedischargephysicalvisitstoer'
                    label='Post Discharge Since Discharge Physical Visits to ER'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargephysicalvisitstoerrefusedtoanswer'
                    name='postdischargesincedischargephysicalvisitstoerrefusedtoanswer'
                    objName='postdischargesincedischargephysicalvisitstoerrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargementalvisitstoer'
                    name='postdischargesincedischargementalvisitstoer'
                    label='Post Discharge Since Discharge Mental Visits to ER'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargementalvisitstoerrefusedtoanswer'
                    name='postdischargesincedischargementalvisitstoerrefusedtoanswer'
                    objName='postdischargesincedischargementalvisitstoerrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>
  
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargephysicalhospadmissions'
                    name='postdischargesincedischargephysicalhospadmissions'
                    label='Post Discharge Since Discharge Physical Hospital Admissions'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargephysicalhospadmissionsrefusedtoanswer'
                    name='postdischargesincedischargephysicalhospadmissionsrefusedtoanswer'
                    objName='postdischargesincedischargephysicalhospadmissionsrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargementalhospadmissions'
                    name='postdischargesincedischargementalhospadmissions'
                    label='Post Discharge Since Discharge Mental Hospital Admissions'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargementalhospadmissionsrefusedtoanswer'
                    name='postdischargesincedischargementalhospadmissionsrefusedtoanswer'
                    objName='postdischargesincedischargementalhospadmissionsrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargetimesinjail'
                    name='postdischargesincedischargetimesinjail'
                    label='Post Discharge Since Discharge Times in Jail'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>        
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargetimesinjailrefusedtoanswer'
                    name='postdischargesincedischargetimesinjailrefusedtoanswer'
                    objName='postdischargesincedischargetimesinjailrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                      locked={this.props.locked}
                      component={renderTextField}
                      id='postdischargesincedischargelongeststayinjail'
                      name='postdischargesincedischargelongeststayinjail'
                      label='Post Discharge Since Discharge Longest Stay in Jail'
                      emptyText='0'
                      footerMessage=''
                    />
                </Grid>
                <Grid item xs={12} sm={6}>        
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargelongeststayinjailrefusedtoanswer'
                    name='postdischargesincedischargelongeststayinjailrefusedtoanswer'
                    objName='postdischargesincedischargelongeststayinjailrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='postdischargesincedischargeovernighthospstay'
                    name='postdischargesincedischargeovernighthospstay'
                    label='Post Discharge Since Discharge Overnight Hospital Stay'
                    emptyText='0'
                    footerMessage=''
                  />
                </Grid>
                <Grid item xs={12} sm={6}>        
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='postdischargesincedischargeovernighthospstayrefusedtoanswer'
                    name='postdischargesincedischargeovernighthospstayrefusedtoanswer'
                    objName='postdischargesincedischargeovernighthospstayrefusedtoanswer'
                    label='Refused to Answer'
                    footerMessage=''
                  />
                </Grid>
              </Grid>


<br />
<hr />
<br />


            <Grid container spacing={3}>  
              <Grid item xs={12} >
                <Field
                  autoFocus
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={EDUCATION_ACHIEVEMENT_OR_CHANGES}
                  id='postdischargeeduachvmntchanges'
                  name='postdischargeeduachvmntchanges'
                  label='Post Discharge Education Achievement or Changes Since Discharge'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>  
              <Grid item xs={12} >
                <Field
                  autoFocus
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={FAMILY_AND_SIGNIFICANT_OTHERS}
                  id='postdischargefamilynsigothers'
                  name='postdischargefamilynsigothers'
                  label='Post Discharge Family &amp; Significant Others Since Discharge'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>  
              <Grid item xs={12} >
                <Field
                  autoFocus
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={ATTEMPTED_CONTACT_RESULTS}
                  id='postdischargehousingsincedischarge'
                  name='postdischargehousingsincedischarge'
                  label='Post Discharge Housing Since Discharge'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>  
              <Grid item xs={12} >
                <Field
                  autoFocus
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={ATTEMPTED_CONTACT_EMPLOYED_STATUS_RESULTS}
                  id='postdischargeemployedsincedischarge'
                  name='postdischargeemployedsincedischarge'
                  label='Post Discharge Employed Since Discharge'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>  
              <Grid item xs={12} >
                <Field
                  autoFocus
                  component={renderSelectField6}
                  locked={this.props.locked}
                  dataArray={POST_DISCHARGE_SUBSTANCE_USE}
                  id='postdischargesubstanceuse'
                  name='postdischargesubstanceuse'
                  label='Post Discharge Substance Use'
                  footerMessage=''
                />
              </Grid>
            </Grid>

<br />
<hr />
<br />

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderCheckbox}
                  locked={this.props.locked}
                  id='postdischargecounselingsupportrefusedtoanswer'
                  name='postdischargecounselingsupportrefusedtoanswer'
                  objName='postdischargecounselingsupportrefusedtoanswer'
                  label='Post Discharge Counseling / Support Refused to Answer'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderCheckbox}
                  locked={this.props.locked}
                  id='postdischargecounselingsupportmedication'
                  name='postdischargecounselingsupportmedication'
                  objName='postdischargecounselingsupportmedication'
                  label='Post Discharge Counseling / Support Medication'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderCheckbox}
                  locked={this.props.locked}
                  id='postdischargecounselingsupportcounseling'
                  name='postdischargecounselingsupportcounseling'
                  objName='postdischargecounselingsupportcounseling'
                  label='Post Discharge Counseling / Support Counseling'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderCheckbox}
                  locked={this.props.locked}
                  id='postdischargecounselingsupportcasemanagement'
                  name='postdischargecounselingsupportcasemanagement'
                  objName='postdischargecounselingsupportcasemanagement'
                  label='Post Discharge Counseling / Support Case Management'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Field
                  component={renderCheckbox}
                  locked={this.props.locked}
                  id='postdischargecounselingsupportsupportgroup'
                  name='postdischargecounselingsupportsupportgroup'
                  objName='postdischargecounselingsupportsupportgroup'
                  label='Post Discharge Counseling / Support Support Group'
                  footerMessage=''
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={POST_DISCHARGE_RATE_QUALITY_OF_LIFE}
                    id='postdischargerateyourqualityoflife'
                    name='postdischargerateyourqualityoflife'
                    label='Post Discharge Rate Your Quality of Life'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

            <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='postdischargechildhospital'
                    name='postdischargechildhospital'
                    label='Post Discharge Child Hospital'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

            <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='postdischargearrestfree'
                    name='postdischargearrestfree'
                    label='Post Discharge Arrest Free'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} >
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='postdischargestatuscomments'
                    name='postdischargestatuscomments'
                    label='Post Discharge Comments'
                    rows='6'
                    emptyText='Your comments should be clear and concise.'
                    footerMessage='Your comments should be clear and concise.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsPostDischargeTabPostDischargeStatus.propTypes = {
  locked: PropTypes.bool,

  postdischargecontactdate90dSelected: PropTypes.string,
  postdischargecontactdate180dSelected: PropTypes.string,
  postdischargecontactdate12mSelected: PropTypes.string,
  postdischargecontactdate24mSelected: PropTypes.string,
}
export default FormFieldsPostDischargeTabPostDischargeStatus;